<template>
  <div style="display: flex;">
    <el-date-picker
      v-model="formValue[0]"
      style="flex: 1"
      :type="type"
      :format="format"
      :value-format="valueformat"
      :picker-options="pickerOptionsStart"
      :placeholder="placeholderStart"
    />
    <span style="padding: 0 5px;display: flex;align-items: center;">至</span>
    <el-date-picker
      v-model="formValue[1]"
      style="flex: 1"
      :type="type"
      :format="format"
      :value-format="valueformatend"
      :picker-options="pickerOptionsEnd"
      :placeholder="placeholderEnd"
    />
  </div>
</template>

<script>
export default {
  name: 'DataPicker',
  model: {
    prop: 'value', // 指向props的参数名
    event: 'change'// 事件名称
  },
  props: {
    value: {
      type: Array,
      default() {
        return ['', '']
      }
    },
    format: { // 时间格式
      type: String,
      default: 'yyyy-MM-dd'
    },
    valueformat: { // 时间格式
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    valueformatend: { // 时间格式
      type: String,
      default: 'yyyy-MM-dd 23:59:59'
    },
    type: { // 显示类型 year/month/date/dates/ week/datetime/datetimerange/ daterange/monthrange
      type: String,
      default: 'date'
    },
    placeholderStart: { // 非范围选择时的占位内容
      type: String,
      default: '开始日期'
    },
    placeholderEnd: { // 非范围选择时的占位内容
      type: String,
      default: '结束日期'
    },
    pickerOptions:{   //日期选择器校验规则  today-可选今天  默认为空-不可选今天
      type:String,
      default:''
    }
  },
  data() {
    return {
      formValue: ['', ''],
      pickerOptionsStart: {
        disabledDate: (time) => {
          // eslint-disable-next-line eqeqeq
          if (this.formValue[1] != '' && this.formValue[1]) {
            const timeStr = new Date(this.formValue[1].replace(/-/g, '/'))
            if(this.pickerOptions == 'today'){
              return time.getTime() >= timeStr
            }else{
              return time.getTime() >= timeStr
            }
          } else {
            return ''
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          // eslint-disable-next-line eqeqeq
          if (this.formValue[0] != '' && this.formValue[0]) {
            const timeStr = new Date(this.formValue[0].replace(/-/g, '/'))
            if(this.pickerOptions == 'today'){
              return time.getTime() <= timeStr - 8.63e7
            }else{
              return time.getTime() <= timeStr
            }
          } else {
            return ''
          }
        }
      }
    }
  },
  watch: {
    formValue(val) {
      this.$emit('change', val)
    },
    value(val) {
      if (typeof val === 'object') {
        if (val[0] != this.formValue[0] || val[1] != this.formValue[1]) {
          this.formValue = val
        }
      } else {
        this.formValue = ['', '']
      }
    }
  },
  created() {
    this.formValue = typeof this.value !== 'object' ? ['', ''] : this.value.length === 2 ? this.value : ['', '']
  }
}
</script>

<style scoped>

</style>
